<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
.app-bar {
  font-family: Kanit;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: var(--v-header_text-base);
}
.v-application .footerdetail {
  font-family: Kanit !important;
  font-size: 12px !important;
  color: var(--v-text_shade-base);
  background-color: white;
  border-top: 1px solid var(--v-button_disable_light-base);
}
.swal2-title {
  font-size: 22px !important;
  font-weight: 500 !important;
  font-family: 'Kanit';
}
.swal2-html-container {
  font-family: 'Kanit';
}
</style>
